import { ToggleGroup, ToggleGroupItem } from "@ad3d/ui";
import { MousePointer2, Move, RotateCw, Scaling } from "lucide-react";
import { StudioContext } from "../../contexts/studio.context";
import { useSelector } from "@xstate/react";
import { SplatTool, splatMachine } from "@ad3d/state-machine";
import { ActorRefFrom } from "xstate";

function SplatToolbar({ splatActor }: { splatActor: ActorRefFrom<typeof splatMachine> }) {
    const activeTool = useSelector(splatActor, (state) => state.context.activeTool);

    const handleValueChange = (value: string) => {
        if (!value) return;
        splatActor.send({ type: 'SPLAT.SET_TOOL', tool: value as SplatTool });
    };

    return (
        <div className="p-1 bg-background/80 backdrop-blur-sm rounded-lg border shadow-sm">
            <ToggleGroup type="single" value={activeTool} onValueChange={handleValueChange}>
                <ToggleGroupItem value="select" aria-label="Select" className="h-9 w-9 p-0">
                    <MousePointer2 className="h-4 w-4" />
                </ToggleGroupItem>
                <ToggleGroupItem value="translate" aria-label="Translate" className="h-9 w-9 p-0">
                    <Move className="h-4 w-4" />
                </ToggleGroupItem>
                <ToggleGroupItem value="rotate" aria-label="Rotate" className="h-9 w-9 p-0">
                    <RotateCw className="h-4 w-4" />
                </ToggleGroupItem>
                <ToggleGroupItem value="scale" aria-label="Scale" className="h-9 w-9 p-0">
                    <Scaling className="h-4 w-4" />
                </ToggleGroupItem>
            </ToggleGroup>
        </div>
    );
}

export function SceneToolbar() {
    const studioActor = StudioContext.useActorRef();
    const splatActor = useSelector(studioActor, (state) => state.children.splat);

    if (!splatActor) return null;

    return (
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex gap-2">
            <SplatToolbar splatActor={splatActor as ActorRefFrom<typeof splatMachine>} />
        </div>
    );
}
